import produce from 'immer';
import {
  GET_OPS_MANAGER_DASHBOARD_REQUEST,
  GET_OPS_MANAGER_DASHBOARD_SUCCESS,
  GET_OPS_MANAGER_DASHBOARD_FAILURE,
  GET_TEAM_MEMBERS_REQUEST,
  GET_TEAM_MEMBERS_SUCCESS,
  GET_TEAM_MEMBERS_FAILURE,
} from './opsManagerDashboard.types';

const initialState = {
  overdueTasks: [],
  coveragePeriods: [],
  activeFiles: [],
  closedFiles: [],
  teamMembers: [],
  isLoadingDashboard: false,
  isLoadingTeamMembers: false,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    // Get Dashboard Data
    case GET_OPS_MANAGER_DASHBOARD_REQUEST:
      draft.isLoadingDashboard = true;
      break;

    case GET_OPS_MANAGER_DASHBOARD_SUCCESS:
      draft.overdueTasks = action.response.overdueTasks || [];
      draft.coveragePeriods = action.response.coveragePeriods || [];
      draft.activeFiles = action.response.activeFiles || [];
      draft.closedFiles = action.response.closedFiles || [];
      draft.isLoadingDashboard = false;
      break;

    case GET_OPS_MANAGER_DASHBOARD_FAILURE:
      draft.isLoadingDashboard = false;
      break;

    // Get Team Members
    case GET_TEAM_MEMBERS_REQUEST:
      draft.isLoadingTeamMembers = true;
      break;

    case GET_TEAM_MEMBERS_SUCCESS:
      draft.teamMembers = action.response || [];
      draft.isLoadingTeamMembers = false;
      break;

    case GET_TEAM_MEMBERS_FAILURE:
      draft.isLoadingTeamMembers = false;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
